<div class="faq-container">
  @for (item of faqItems ?? []; track item.question) {
    <div class="faq-item">
      <div
        class="faq-question"
        [class.mobile]="isMobile"
        (click)="toggleFAQ($index)"
      >
        {{ item.question }}
        <span class="faq-icon">{{ item.open ? '–' : '+' }}</span>
      </div>
      <div
        class="faq-answer"
        [class.open]="item.open"
        [class.mobile]="isMobile"
      >
        <p [innerHTML]="item?.description"></p>

        @if (item.specialList) {
          <div class="special-list">
            @for (specialItem of item.specialList; track specialItem.title) {
              <div class="special-list-item">
                <div class="special-item-title">{{ specialItem.title }}</div>
                <ul class="special-item-content">
                  <li>
                    {{ specialItem.description }}
                    <ul class="example-list">
                      @for (example of specialItem.examples; track example) {
                        <li>Example: {{ example }}</li>
                      }
                    </ul>
                  </li>
                </ul>
              </div>
            }
          </div>
        }

        @if (item.listItems && !item.specialList) {
          <ul
            class="faq-list"
            [class.numbered]="item?.listType === 'numbered'"
          >
            @for (listItem of item.listItems; track $index) {
              <li>
                @if (typeof listItem === 'string') {
                  <span [innerHTML]="listItem"></span>
                } @else {
                  {{ listItem.text }}
                  @if (listItem.link) {
                    <a
                      class="faq-answer_link"
                      href="#"
                      (click)="onFaqLinkClick(listItem.link); $event.preventDefault()"
                      >{{ listItem.link.label }}</a
                    >
                  }
                }
              </li>
            }
          </ul>
        }

        @if (item.subDescription) {
          <p class="sub-description">
            @if (typeof item.subDescription === 'string') {
              <span [innerHTML]="item.subDescription"></span>
            } @else if (item.subDescription?.link) {
              <a
                class="faq-answer_link"
                [routerLink]="item.subDescription.link.route"
                >{{ item.subDescription.link.label }}</a
              >
            }
          </p>
        }
      </div>
    </div>
  }
</div>
